import { c as _c } from "react/compiler-runtime";
import type { ListingCardProps } from "./listing-card.types";
import { StoreCard } from "./variants/store-card";
import { EventCard } from "./variants/event-card";
import { HotelCard } from "./variants/hotel-card";
import { ArticleCard } from "./variants/article-card";
import { VendorCard } from "./variants/vendor-card";
import { PromoCard } from "./variants/promo-card";
import { ShoppingGuideCard } from "../shopping-guide-card";
export function ListingCard(props) {
  const $ = _c(17);
  switch (props.variant) {
    case "store":
      {
        let t0;
        if ($[0] !== props) {
          t0 = <StoreCard {...props} />;
          $[0] = props;
          $[1] = t0;
        } else {
          t0 = $[1];
        }
        return t0;
      }
    case "event":
      {
        let t0;
        if ($[2] !== props) {
          t0 = <EventCard {...props} />;
          $[2] = props;
          $[3] = t0;
        } else {
          t0 = $[3];
        }
        return t0;
      }
    case "hotel":
      {
        let t0;
        if ($[4] !== props) {
          t0 = <HotelCard {...props} />;
          $[4] = props;
          $[5] = t0;
        } else {
          t0 = $[5];
        }
        return t0;
      }
    case "article":
      {
        let t0;
        if ($[6] !== props) {
          t0 = <ArticleCard {...props} />;
          $[6] = props;
          $[7] = t0;
        } else {
          t0 = $[7];
        }
        return t0;
      }
    case "vendor":
      {
        let t0;
        if ($[8] !== props) {
          t0 = <VendorCard {...props} />;
          $[8] = props;
          $[9] = t0;
        } else {
          t0 = $[9];
        }
        return t0;
      }
    case "promo":
      {
        let t0;
        if ($[10] !== props) {
          t0 = <PromoCard {...props} />;
          $[10] = props;
          $[11] = t0;
        } else {
          t0 = $[11];
        }
        return t0;
      }
    case "shoppingGuide":
      {
        const t0 = props.visual ?? undefined;
        let t1;
        if ($[12] !== props.className || $[13] !== props.href || $[14] !== props.title || $[15] !== t0) {
          t1 = <ShoppingGuideCard headline={props.title} slug={props.href} visual={t0} className={props.className} />;
          $[12] = props.className;
          $[13] = props.href;
          $[14] = props.title;
          $[15] = t0;
          $[16] = t1;
        } else {
          t1 = $[16];
        }
        return t1;
      }
  }
}